import * as Yup from 'yup';

export const aggInventoryInitialValues = {
    description: '',
    startDate: null,
    endDate: null,
    amount: '',
    purchaseId: '',
    referenceId: '',
    expiresAt: null,
    venue: '',
};

export const aggInventorySchema = Yup.object({
    startDate: Yup.date().nullable(),
    endDate: Yup.date().nullable(),
    amount: Yup.number().nullable(),
    purchaseId: Yup.string().nullable(),
    referenceId: Yup.string().nullable(),
    description: Yup.string().nullable(),
    expiresAt: Yup.date().nullable(),
    venue: Yup.string().nullable(),
});
